/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// CD CODE
document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelectorAll('.template-collection').length > 0){
    var win = window;
    var isInProgress = false;
    win.addEventListener('scroll',(event) => {
      if(!isInProgress) {
        if (((window.pageYOffset || document.documentElement.scrollTop)+win.innerHeight) >= document.querySelector('#shopify-section-footer').offsetTop) {
          isInProgress = true;
          var collection_loader = document.querySelectorAll("#js_loader")[0];
          if(collection_loader){
            var $this = this;
            var next_url = document.querySelector(".load_more_wrap").getAttribute("data-next-url");
            var total_pages = parseInt(document.querySelector(".load_more_wrap").getAttribute("data-total-pages"));
            var current_pages = parseInt(document.querySelector(".load_more_wrap").getAttribute("data-current-page"));
            document.querySelector(".load_more_wrap button").classList.add("loading");
            document.querySelector(".load_more_wrap button").classList.remove("hide");
      
            current_pages = current_pages+1;
            document.querySelector(".load_more_wrap").setAttribute("data-current-page",current_pages);
            var new_url = next_url.replace(/page=[0-9]+/,'page='+current_pages);
      
            fetch(new_url)
            .then((response) => response.text())
            .then((responseText) => {
              var doc = new DOMParser().parseFromString(responseText, "text/html");
              var grid_html = doc.querySelector('.ProductList').innerHTML;
              document.querySelector(".ProductList").innerHTML += grid_html;
              if(current_pages >= total_pages){
                document.querySelector(".load_more_wrap").classList.add("hide");
              }
              document.querySelector(".load_more_wrap button").classList.remove("loading");
              document.querySelector(".load_more_wrap button").classList.add("hide");
  
              document.querySelectorAll(".ProductItem:not([style])").forEach(function(item) {
                item.style.cssText = 'visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0);';
              });
              
              isInProgress = false;
            });
          }
        }
      }
    });
  }
});

window.addEventListener("load", (event) => {
  if(document.querySelectorAll(".ProductForm__BuyButtons .shopify-payment-button__button").length > 0){
    setTimeout(function(){document.querySelector(".ProductForm__BuyButtons .shopify-payment-button__button").innerText = 'קנה עכשיו';}, 1000);
  }
});


// This script waits until the entire window is loaded, including all frames, objects, and images
window.onload = function() {

    // Now we attempt to select elements using the previously discussed selectors
    var drawerContainers = document.querySelectorAll('.Drawer__Container');
    var sidebarNavs = document.querySelectorAll('.Drawer__Container .SidebarMenu__Nav');
    var collapsibleButtons = document.querySelectorAll('.Drawer__Container .SidebarMenu__Nav .Collapsible__Button');

    // If we find any collapsible buttons, we'll iterate through them and check the text content
    if (collapsibleButtons.length > 0) {
        collapsibleButtons.forEach(function(button) {
           // console.log('Checking button:', button.textContent.trim()); // Log each button's text
            if (button.textContent.trim().includes("SUMMER UP TO")) { // Check if the text includes the desired substring
                button.style.color = '#ff0000'; // Change the text color to red
            } else {
                //console.log('No match found for:', button.textContent.trim()); // Log no match found
            }
        });
    } else {
        console.log('No collapsible buttons found'); // Log if no buttons were found
    }
};
document.addEventListener('DOMContentLoaded', function() {
    var isMobile = window.innerWidth <= 768; // Adjust threshold if needed

    // Select both sections
    var desktopSection = document.querySelector('.Section.background_video_change[data-device="desktop"]');
    var mobileSection = document.querySelector('.Section.background_video_change[data-device="mobile"]');

    // Show the appropriate section
    if (isMobile && mobileSection) {
      mobileSection.style.display = 'block';
      console.log('Displaying mobile section');
    } else if (!isMobile && desktopSection) {
      desktopSection.style.display = 'block';
      console.log('Displaying desktop section');
    }

    // Listen for window resizing
    window.addEventListener('resize', function() {
      isMobile = window.innerWidth <= 768; // Update isMobile on resize

      // Hide both sections initially
      if (mobileSection) mobileSection.style.display = 'none';
      if (desktopSection) desktopSection.style.display = 'none';

      // Show the appropriate section on resize
      if (isMobile && mobileSection) {
        mobileSection.style.display = 'block';
      } else if (!isMobile && desktopSection) {
        desktopSection.style.display = 'block';
      }
    });
  });


$(document).ready(function() {
  console.log('VERSION - 3.4')
  var checkoutButton = $('.btn.Cart__Checkout.Button.Button--primary.Button--full');
  checkoutButton.addClass('disabled');
  checkoutButton.prop('disabled', true);
})
$(document).on('change', 'input#termsCheckbox', function() {
  var termsCheckbox = $('#termsCheckbox');
  var checkoutButton = $('.btn.Cart__Checkout.Button.Button--primary.Button--full');
  var errorText = $('#termsError');
  if (this.checked) {
    //console.log('Checkbox is checked, enabling button');
    checkoutButton.removeClass('disabled');
    checkoutButton.prop('disabled', false);
    errorText.hide();
  } else {
    //console.log('Checkbox is not checked, disabling button');
    checkoutButton.addClass('disabled');
    checkoutButton.prop('disabled', true);
    errorText.show();
  }
});
